export default __webpack_public_path__ + "static/media/term_condition.127b2404.svg";